import React from "react";

const Layout: React.FC<{ children: React.ReactNode }> = ({children}) => {
    return (
        <div className="pkt-grid pkt-grid--laptop pkt-grid--center px-size-8 px-size-16--phablet-up">
            {children}
        </div>
    );
};

export default Layout;
